import React from 'react';
import { Button, Typography } from '@mui/material';
import Modal from 'react-bootstrap/Modal';
import whatsapp from '../../../../image/whatsappIconGrey.svg';
import {atendimetoWhatsapp} from '../../../../function';
// import phone from '../../../../image/phoneIconGrey.svg';

// import { Container } from './styles';

function ModalAviso({mostrar, handleClose}) {
    return (
        <Modal show={mostrar} onHide={handleClose} centered>
            <Modal.Header closeButton style={{paddingTop: 0, paddingBottom:0}}>
                <Modal.Title style={{
                    color: "var(--main-bg-color)", 
                    width: "100%", 
                    textAlign: 'center',
                    fontSize: 35
                }}>Aviso</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div style={{marginLeft: 50,marginRight: 50, marginTop: 0}}>
                <div>
                    <Typography style={{
                        textAlign: "center",
                        color:'var(--main-secondy)',
                        fontSize: 25
                        }}>
                        Esse contrato foi suspenso!
                    </Typography>
                    <Typography variant="body2" 
                        style={{
                            textAlign: "center", 
                            fontSize: 16, 
                            paddingLeft: 50, 
                            paddingRight: 50, 
                            paddingTop: 10, 
                            paddingBottom:10}}>
                        Entre em contato com a central de atendimento em caso de dúvidas.
                    </Typography>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', margin: 10}}>
                       
                        <div style={{cursor: 'pointer'}}
                        onClick={atendimetoWhatsapp}>
                            <img
                            src={whatsapp}
                                height="30"
                                width="30"
                                alt="Whatsapp"
                                style={{height: 30, width: 30, minWidth: 30, marginLeft: 10}}
                            />
                        </div>
                    </div>
                </div>
            </div>
            </Modal.Body>
            <Modal.Footer>
                <div  onClick={() => handleClose()}>
                    <Button style={{backgroundColor: "var(--main-bg-color)"}} variant="contained">
                        De Acordo
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalAviso;